import React from 'react'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import styled from 'styled-components'
import FormErrorMessage from 'components/atoms/FormErrorMessage'
import BaseButton from 'components/atoms/Button'
import { mediaMin, mediaMax } from 'frontend_core/dist/styles/media'
import { Input, Checkbox } from 'antd'
import Colors from 'styles/colors'

import * as Presenter from './SignUpFormPresenter'

const Button = styled(BaseButton)`
  ${mediaMax.phone`
    height: 48px;
    padding-top: 16px;
    padding-bottom: 16px;
    border-radius: 40px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
    box-sizing: border-box;
  `}
`

export default props => {
  const { account, onSubmit, onChange } = props

  return (
    <div>
      <div className="signup-box__note-wrap">
        <p className="signup-box__note">
          以下メールアドレスでのご登録はお控えください。
        </p>
        <ul className="signup-box__note-list">
          <li>
            <span className="icon-spm-close signup-box__list-icon" />
            @docomo、@ezweb、@softbankなどのキャリアメール
          </li>
        </ul>
      </div>
      <input name="utf8" type="hidden" value="✓" />
      <input
        type="hidden"
        value="0"
        name="user[registration_type]"
        id="user_registration_type"
      />
      <div className="col-sm-12">
        <FamilyNameInput>
          <InputComponent
            onChange={onChange}
            className="w100pa"
            id="account_name"
            name="accountName"
            value={account.accountName}
            placeholder="アカウント名"
          />
          {account.errors && account.errors.name && (
            <FormErrorMessage>{account.errors.name}</FormErrorMessage>
          )}
        </FamilyNameInput>
      </div>
      <div className="col-sm-12">
        <EmailInput>
          <InputComponent
            onChange={onChange}
            className="w100pa"
            name="email"
            type="email"
            value={account.email}
            placeholder={i18n.t('page.shared.l_00046')}
          />
          {account.errors && account.errors.email && (
            <FormErrorMessage>{account.errors.email}</FormErrorMessage>
          )}
        </EmailInput>
      </div>
      <div className="col-sm-12">
        <EmailInput>
          <InputComponent
            onChange={onChange}
            className="w100pa"
            type="password"
            value={account.password}
            name="password"
            placeholder={i18n.t('page.shared.l_00061')}
          />
          {account.errors && account.errors.password && (
            <FormErrorMessage>{account.errors.password}</FormErrorMessage>
          )}
        </EmailInput>
      </div>
      <div className="col-sm-12">
        <EmailInput>
          <InputComponent
            onChange={onChange}
            className="w100pa"
            type="password"
            value={account.passwordConfirmation}
            name="passwordConfirmation"
            placeholder={i18n.t('page.shared.l_00062')}
          />
          {account.errors && account.errors.password_confirmation && (
            <FormErrorMessage>
              {account.errors.password_confirmation}
            </FormErrorMessage>
          )}
        </EmailInput>
      </div>
      <div className="col-sm-12 ta-c">
        <div
          id="google-recaptcha"
          style={{
            margin: '0 auto',
            marginTop: '15px',
            width: '304px',
            height: '78px',
          }}
        />
      </div>
      <Presenter.SignUpFormAgree>
        <CheckboxComponent
          id="checkbox-1"
          onClick={onChange}
          checked={account.acceptTermOfService}
          name="acceptTermOfService"
        >
          規約に同意する
        </CheckboxComponent>
        {account.errors?.accept_term_of_service && (
          <FormErrorMessage>規約に同意してください。</FormErrorMessage>
        )}
      </Presenter.SignUpFormAgree>
      <div className="col-sm-12 ta-c">
        <Button
          onClick={onSubmit}
          disabled={!props.onSubmit}
          type="button"
          colorType="blue"
          fontWeight
          buttonType="largeFull"
          buttonMargin="24px 0 0 0"
        >
          {i18n.t('page.shared.l_00004')}
        </Button>
      </div>
    </div>
  )
}

const FamilyNameInput = styled.div`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 20px 0 5px;
`

const EmailInput = styled.div`
  position: relative;
  font-size: 14px;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 20px 0 5px;
  margin: 0 auto;
`

const AgreeCheck = styled.div`
  margin: 0 16px;
  ${mediaMin.phone`
    margin: 0 60px;
  `};
  &:first-of-type {
    padding-bottom: 16px;
  }
`

const InputComponent = styled(Input)`
  height: 40px;

  &.ant-input {
    border-radius: 6px;
    border-color: ${Colors.mono.gray40};
    font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
      'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
      'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
      'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    font-size: 14px;
    &::-webkit-input-placeholder {
      color: ${Colors.mono.gray40};
    }
    &:hover {
      border-color: ${Colors.brand.primary.main};
    }
    &.ant-input-disabled {
      &:hover {
        border-color: #e6d8d8;
      }
    }
    &:focus {
      border-color: ${Colors.brand.primary.main};
      box-shadow: none;
    }
  }
  &.ant-input-affix-wrapper {
    .ant-input {
      height: 40px;
      font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
        'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
        'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
        'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
      font-size: 14px;
      &::-webkit-input-placeholder {
        color: ${Colors.mono.gray40};
      }
      &:hover {
        border-color: ${Colors.brand.primary.main};
      }
      &.ant-input-disabled {
        &:hover {
          border-color: #e6d8d8;
        }
      }
      &:focus {
        border-color: ${Colors.brand.primary.main};
        box-shadow: none;
      }
    }
    :hover .ant-input:not(.ant-input-disabled) {
      border-color: ${Colors.brand.primary.main};
    }
  }
`

const CheckboxComponent = styled(Checkbox)`
  &.ant-checkbox-wrapper {
    display: flex;
    font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
      'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
      'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
      'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    .ant-checkbox-inner {
      top: 1px;
      width: 20px;
      height: 20px;
      :after {
        top: 50%;
        left: 50%;
        transform: rotate(45deg) scale(0) translate(-50%, -50%);
        transform-origin: top;
      }
      .ant-checkbox-input {
        &:focus {
          border-color: ${Colors.brand.primary.main};
        }
      }
    }
    .ant-checkbox {
      vertical-align: top;
    }
    .ant-checkbox-wrapper + span,
    .ant-checkbox + span {
      line-height: 1.35;
      font-size: 14px;
    }
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${Colors.brand.primary.main};
    }
    .ant-checkbox-checked {
      &.ant-checkbox-disabled .ant-checkbox-inner:after {
        border-color: ${Colors.mono.white};
      }
      &:after {
        border: none;
      }
      .ant-checkbox-inner {
        &:after {
          -webkit-transition: none;
          transition: none;
          transform: rotate(45deg) scale(1) translate(-50%, -50%);
        }
      }
    }
    &:hover {
      .ant-checkbox-inner,
      .ant-checkbox:hover .ant-checkbox-inner,
      .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: ${Colors.brand.primary.main};
      }
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${Colors.mono.white};
      border-color: ${Colors.brand.primary.main};
    }
    .ant-checkbox-checked .ant-checkbox-inner:after {
      border-color: ${Colors.brand.primary.main};
    }
  }
`
